module.exports = __webpack_public_path__ + "static/media/config.6f5e3332.svg";